jQuery(document).ready(function($) {
  if ($("section.open-house-calendar").length) {
    console.log("Open House Calendar JS File");

    /******************************************
     ***       Slider of Open Houses        ***
     ******************************************/
    var $ohSlider = $(".open-house-calendar .owl-carousel");
    $ohSlider
      .owlCarousel({
        nav: true,
        items: 1,
        dots: false,
        singleItem: true,
        onInitialized: updateActiveDate
      })
      .on("changed.owl.carousel", function(event) {
        updateSliderAndCalendar(event.item.index);
      });

    function updateActiveDate() {
      $(".open-house-calendar .owl-item").each(function(index, el) {
        if ($(el).hasClass("active")) {
          var newDate = $(this)
              .children()
              .data("date"),
            newTime = $(this)
              .children()
              .data("time");
          $(".open-house-calendar")
            .attr("data-datevalue", newDate)
            .data("datevalue", newDate);
          $(".open-house-calendar")
            .attr("data-timevalue", newTime)
            .data("timevalue", newTime);
        }
      });

      // Actually initialize Calendar
      var today = new Date(),
        all_oh_dates = $(".open-house-calendar").data("alldates"),
        $theCalendar = $("#calendar");
      if (all_oh_dates) {
        // console.log($theCalendar, all_oh_dates, today);
        calender_event($theCalendar, today, all_oh_dates);
      } else {
        // what happens if no dates show?
      }
    }

    function updateSliderAndCalendar(slideIndex) {
      $(".open-house-day").each(function(index, el) {
        if ($(el).data("index") == slideIndex) {
          var newDate = $(this).data("date"),
            newTime = $(this).data("time"),
            all_oh_dates = $(".open-house-calendar").data("alldates"),
            $theCalendar = $("#calendar");
          $(".open-house-calendar")
            .data("datevalue", newDate)
            .attr("data-datevalue", newDate);
          $(".open-house-calendar")
            .data("timevalue", newTime)
            .attr("data-timevalue", newTime);
          calender_event($theCalendar, newDate, all_oh_dates);
        }
      });
    }

    /******************************************
     ***   END Slider of Open Houses        ***
     ******************************************/
    /******************************************
     ***     Calendar for Open Houses       ***
     ******************************************/

    // function to create the calendar
    function calender_event(element, current_date, myDisabledDays) {
      if (myDisabledDays) {
        //console.log(myDisabledDays);
        var disabledDays = [];
        disabledDays = myDisabledDays.split(",");
      } else {
        disabledDays = "0";
      }

      $(element).datepicker("destroy");
      $(element).datepicker({
        minDate: 0,
        dateFormat: "mm/dd/yy",
        defaultDate: current_date,
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
        onSelect: function(date, obj) {
          $(".open-house-calendar")
            .data("datevalue", date)
            .attr("data-datevalue", date); //Updates value of of your input

          //$( "#" + obj.id ).attr( "data-value", date );
          //$( "#date_input" ).val( current_date ); //Updates value of of your input – TODO, integrate this w/ forms
          //var newDate = $( this ).children().data( 'date' );
          var date_value = $(".open-house-calendar").data("datevalue");

          //var post_id_value = $( "#cuurent_pop_evnt_date" ).val( date_value );
          $(".ui-datepicker-calendar")
            .find(".ui-state-active")
            .removeClass("ui-datepicker-current-day");
          var arr = date_value.split("/");
          var curdate = parseInt(arr[0]);
          var curmonth = parseInt(arr[1]);
          var finlmnth = parseInt(curmonth - 1);
          var curyear = arr[2];

          window.globalVar = curdate;

          $ee = $(".ui-datepicker-calendar")
            .find("td[data-month='" + finlmnth + "']")
            .children(".ui-state-default")
            .filter(function() {
              return $(this).text() == globalVar;
            });
          $ee = $ee.parent("td");

          $ee.addClass("eventdate ui-datepicker-current-day");
          $ee.css("z-index", "-1");

          $(".open-house-calendar .open-house-day").each(function() {
            var eventDate = $(this).data("date");
            if (eventDate == date_value) {
              $($ohSlider).trigger("to.owl.carousel", $(this).data("index"));
              //var itemN = $( this ).data( 'index' );
              //$( "#cuurent_pop_evnt_date" ).val( itemN );
            }
          });
        },
        beforeShowDay: function(date) {
          var m = date.getMonth();
          var d = date.getDate();
          var y = date.getFullYear();

          for (i = 0; i < disabledDays.length; i++) {
            if ($.inArray(y + "-" + (m + 1) + "-" + d, disabledDays) != -1) {
              return [true, "ui-state-active eventdate", ""];
            } else {
              return [true, "ui-datepicker-unselectable", ""];
            }
          }
          return [true];
        }
      });
      $(element).datepicker("refresh");
    }
    /******************************************
     ***    END Calendar for Open Houses    ***
     ******************************************/
    /******************************************
     ***     Register to Attend Form        ***
     ******************************************/
    $("form.register-to-attend button[type=submit]").click(function(event) {
      event.preventDefault();

      // Update Hidden Form Fields w/ Info from Calendar & Info that we can't put in dynamically with PHP on the template:
      $("#input_7_11").val($(".open-house-calendar").data("timevalue")); // Open House Time
      $("#input_7_12").val($(".open-house-calendar").data("datevalue")); // Open House Date
      $("#input_7_13").val(window.location.href); // Property's URL

      $.ajax({
        type: "POST",
        url:
          my_template_url +
          "/template-parts/custom-emails/register-to-attend-email.php",
        data: $($("form.register-to-attend")).serialize(),
        success: function(server_response_data) {
          $(".rta-form")
            .children()
            .html(server_response_data);
        }
      });
    });
    /******************************************
     ***     END Register to Attend Form    ***
     ******************************************/
    /******************************************
     ***     Request a Showing Form         ***
     ******************************************/
    $("form.request-a-showing button[type=submit]").click(function(event) {
      event.preventDefault();

      // Update Hidden Form Fields w/ Info that we can't put in dynamically with PHP on the template
      $("#input_6_15").val(window.location.href); // Property's URL

      $.ajax({
        type: "POST",
        url:
          my_template_url +
          "/template-parts/custom-emails/request-a-showing-email.php",
        data: $($("form.request-a-showing")).serialize(),
        success: function(server_response_data) {
          $(".rs-form")
            .children()
            .html(server_response_data);
        }
      });
    });
    /******************************************
     ***     END Request a Showing Form     ***
     ******************************************/
  }
});
